import type { SVGProps } from "react";
export interface DrowningIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DrowningIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DrowningIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 18.884a1.77 1.77 0 0 1 1.95 0l.123.089.196.15c.46.333 1.129.696 1.868.746l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.306-.085-2.371-.687-3.02-1.153-.701.503-1.885 1.163-3.333 1.163s-2.634-.66-3.334-1.163c-.7.503-1.885 1.163-3.333 1.163s-2.633-.66-3.333-1.163c-.701.503-1.885 1.163-3.333 1.163a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.514 2.237-.902l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.359 1.233.752 2.04.752.922 0 1.755-.514 2.236-.902l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.359 1.232.752 2.039.752.923 0 1.755-.514 2.237-.902l.121-.09Zm0-4a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.332 1.129.695 1.868.745l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.503-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.503-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162c-.701.503-1.885 1.162-3.333 1.162a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.513 2.237-.901l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.357 1.233.75 2.04.75.922 0 1.755-.512 2.236-.9l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.357 1.232.75 2.039.75.922 0 1.755-.512 2.237-.9zm-.738-11.297a1.125 1.125 0 0 1 2.093.825l-.533 1.354a8.24 8.24 0 0 1-4.214 4.459l.165 1.563.006.115a1.125 1.125 0 0 1-2.226.235l-.018-.115-.133-1.25-1.241.13.127 1.21.006.116a1.126 1.126 0 0 1-2.226.231l-.018-.114-.136-1.295a13 13 0 0 1-2.51-.264l-.506-.114-2.359-.58-.11-.034a1.126 1.126 0 0 1 .535-2.174l.114.022 2.359.582.419.094a10.9 10.9 0 0 0 3.309.162l2.351-.245a3.6 3.6 0 0 0 1.13-.309 6 6 0 0 0 3.083-3.25zM11.375 4.75a.626.626 0 1 0-1.252.001.626.626 0 0 0 1.252 0Zm2.25 0a2.875 2.875 0 1 1-5.75-.002 2.875 2.875 0 0 1 5.75.002"
      />
    </svg>
  );
}
